import * as React from 'react';
import styled from 'styled-components';
import { Top, Step } from '../top/Top';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SMainContentInner = styled.div<{ scroll?: boolean; height?: string; maxWidth?: string }>(
  ({ scroll = true, height, maxWidth, theme }) => `
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: ${scroll ? 'scroll' : 'hidden'};
  padding: 46px 61px 32px 61px;
  height: ${height || '515px'};
  min-width: 588px;
  max-width: ${maxWidth || 'none'};
  @media only screen and ${theme.device.max.laptopS} {
    overflow: visible;
    overflow-y: visible;
    padding: 46px 32px 46px 32px;
    height: ${height || 'auto'};
    min-width: auto;
  }
`
);

const SMainContentBox = styled.div<{ boxMarginBottom?: string; boxMarginTop?: string }>(
  ({ boxMarginBottom, boxMarginTop, theme }) => `
  margin-bottom: ${boxMarginBottom || '0px'};
  margin-top: ${boxMarginTop || '0px'};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 0px 0px 15px 3px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08);
  @media only screen and ${theme.device.max.laptopS} {
    box-shadow: none;
  }
`
);

const StyledModalLayout = styled.div<{}>(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.white};
  justify-content: center;
  align-items: center;
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IMainLayoutProps {
  page: {
    step?: number;
    steps?: Step[];
    stepProgress?: number;
    text: string;
    secondTitle?: string;
    hideExitApplication?: boolean;
    scroll?: boolean;
    height?: string;
    boxMarginBottom?: string;
    boxMarginTop?: string;
    maxWidth?: string;
  };
  children?: React.ReactNode;
}

const MainLayout: React.FC<IMainLayoutProps> = ({ page, children }) => {
  return (
    <StyledModalLayout data-at="mainLayout">
      <Top currentStepNumber={page.step} currentStepProgress={page.stepProgress} steps={page.steps} />
      <SMainContentBox boxMarginBottom={page.boxMarginBottom} boxMarginTop={page.boxMarginTop}>
        <SMainContentInner scroll={page.scroll} height={page.height} maxWidth={page.maxWidth}>
          {children}
        </SMainContentInner>
      </SMainContentBox>
    </StyledModalLayout>
  );
};

export default MainLayout;
